define('collections/appsAccessUsersBin',["jQuery", "Underscore", "T1", "T1Collection", "models/appsAccessUsersBin", "T1Sortable"], function ($, _, T1, T1Collection, Model, Sortable) {
  "use strict";

  T1Collection.extend({
    apiRoot: T1.API_APPS_ROOT,
    canCache: false,
    cacheDuration: 6e4,
    model: Model,
    urlString: ""
  });
  return T1.Models.AppsAccessUsersBin;
});
